<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="col-md-12">
                <h5 class="text-primary">
                  Vendor Report
                </h5>
              </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <dl class="row dl-custom">
                            <dt class="col-md-4">Report By</dt>
                            <dd class="col-md-8">
                                <select class="form-control" v-model="reportStatus">
                                    <option value="last-order">Last Order</option>
                                    <option value="by-date">By Date</option>
                                </select>
                            </dd>
                            <dt class="col-md-4">Vendor</dt>
                            <dd class="col-md-8">
                                <v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="vendorNo"/>
                            </dd>

                            <dt class="col-md-4">&nbsp;</dt>
                            <dd class="col-md-8">
                                <button type="button" class="btn btn-sm btn-hard-primary" @click="refreshList">
                                    <i class="fa fa-search"></i> Search
                                </button>
                            </dd>
                        </dl>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table table-item table-sm table-hover table-stripred">
                                <thead>
                                    <th>Purchasing No</th>
                                    <th>Order No</th>
                                    <th>Tgl.</th>
                                    <th>Product No</th>
                                    <th>Product</th>
                                    <th>Qty</th>
                                    <th>Qty Pembelian</th>
                                    <th>Qty Selisih</th>
                                    <th>Uom</th>
                                    <th>Price</th>
                                    <th>Purchasing</th>
                                </thead>
                                <tbody>
                                    <tr v-for="d in filterData" :key="d.id">
                                        <td>{{ d.purchasing_no }}</td>
                                        <td>{{ d.sp_no }}</td>
                                        <td>{{ d.purchasing_date | dateFormat('DD/MM/YYYY/') }}</td>
                                        <td>{{ d.product_no }}</td>
                                        <td>{{ d.product }}</td>
                                        <td>{{ d.qty }}</td>
                                        <td>{{ d.qty_done }}</td>
                                        <td>{{ d.qty_remaining }}</td>
                                        <td>{{ d.uom_id }}</td>
                                        <td>{{ d.price | currency }}</td>
                                        <td>
                                            <span v-for="p in d.purchasing" :key="p.id" style="color: blue;">{{ p.ext_no }} |</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <pre> {{ filterData }}</pre>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, vendorUrl } from '../config'
import { mapState } from 'vuex'
export default {
  name: 'VendorReport',
  data () {
    return {
      vendorNo: null,
      dataRaw: [],
      reportStatus: 'last-order'
    }
  },
  computed: {
    ...mapState({
      vendorList: state => state.vendors.vendorList
    }),
    filterData () {
      var loop = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var detail = array[i].details
        var po = []
        if (array[i].purchasing.length > 0) {
          po = array[i].purchasing
        } else {
          po = [{
            id: null,
            purchasing_no: null,
            sp_no: null
          }]
        }
        for (let a = 0; a < detail.length; a++) {
          var obj = {
            id: detail[a].id,
            purchasing_no: detail[a].purchasing_no,
            purchasing_date: detail[a].purchasing_date,
            product_no: detail[a].product_no,
            product: detail[a].product,
            qty: detail[a].qty,
            qty_done: detail[a].qty_done,
            qty_remaining: parseInt(detail[a].qty - detail[a].qty_done),
            uom_id: detail[a].uom_id,
            sp_no: array[i].sp_no,
            price: detail[a].price,
            purchasing: po
          }
          loop.push(obj)
        }
      }
      return loop
    },
    vendorSelect () {
      var loop = []
      var array = this.vendorList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].vendor_no + ' - ' + array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  mounted () {
    this.$store.dispatch('getVendorList')
  },
  methods: {
    async refreshList () {
      var data = {
        vendor_no: this.vendorNo,
        report_status: this.reportStatus
      }
      console.log(data)
      await Axios.post(vendorUrl + '/order', data, { headers: getHeader() })
        .then(response => {
          console.log(response)
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    }
  }
}
</script>
